<div class="p-6 space-y-6" id="page-proyectos">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Proyectos</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Constructora Azteca S.A. · 12 proyectos activos</p>
    </div>
    <button type="button" class="btn btn-primary gap-2 w-full sm:w-auto">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nuevo Proyecto
    </button>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 overflow-hidden">
    <div class="px-4 py-3 flex flex-col lg:flex-row gap-3 border-b border-gray-100 dark:border-gray-800">
      <label class="input w-full lg:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar por nombre..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Tipo: Todos</option>
        <option>Construcción</option>
        <option>Ambiental</option>
        <option>Mercantil</option>
        <option>Comercial</option>
      </select>
      <select class="select w-full sm:w-auto">
        <option>Estado: Todos</option>
        <option>En proceso</option>
        <option>En revisión</option>
        <option>Completado</option>
        <option>Vencido</option>
      </select>
      <select class="select w-full sm:w-auto">
        <option>Ubicación: Todas</option>
        <option>CDMX</option>
        <option>Monterrey</option>
        <option>Guadalajara</option>
      </select>
    </div>

    <div class="p-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition overflow-hidden">
        <div class="h-2 bg-linear-to-r from-orange-500 to-red-500"></div>
        <div class="p-5">
        <div class="items-start justify-between mb-3 flex">
          <div>
            <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-0.5 rounded-lg font-medium
                      dark:text-blue-400">Construcción</span>
            <h4 class="font-bold text-gray-800 text-sm mt-1.5 dark:text-white">Licencia Construcción Lote 14</h4>
          </div>
          <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-0.5 rounded-lg
                    font-medium dark:text-orange-400">En proceso</span>
        </div>
        <p class="text-xs text-gray-500 items-center mb-3 dark:text-gray-400 flex gap-1">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_hOF9XZSYI"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path></svg>
          Benito Juárez, CDMX
        </p>
        <div class="items-center mb-4 flex gap-2">
          <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-2 flex-1">
            <div style="width: 65%;" class="bg-linear-to-r h-2 rounded-full from-orange-500 to-red-400"></div>
          </div>
          <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">65%</span>
        </div>
        <div class="items-center justify-between flex">
          <span class="text-xs text-gray-400 dark:text-gray-500">
            Vence:
            <span class="text-red-500 font-medium">15 Nov 2024</span>
          </span>
          <div class="flex gap-1">
            <button type="button" class="btn btn-ghost btn-square btn-sm">
              <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
            </button>
            <a routerLink="/tareas" class="btn btn-ghost btn-square btn-sm text-primary inline-flex">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6M3 21h18M3 10l9-7 9 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      </div>

      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition overflow-hidden">
        <div class="h-2 bg-linear-to-r from-blue-500 to-cyan-500"></div>
        <div class="p-5">
        <div class="items-start justify-between mb-3 flex">
          <div>
            <span class="text-xs bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 px-2 py-0.5 rounded-lg font-medium dark:text-cyan-400">Ambiental</span>
            <h4 class="font-bold text-gray-800 text-sm mt-1.5 dark:text-white">Manifestación de Impacto Torre Norte</h4>
          </div>
          <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-0.5 rounded-lg font-medium dark:text-blue-400">En revisión</span>
        </div>
        <p class="text-xs text-gray-500 items-center mb-3 dark:text-gray-400 flex gap-1">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path></svg>
          San Pedro, Monterrey
        </p>
        <div class="items-center mb-4 flex gap-2">
          <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-2 flex-1">
            <div style="width: 82%;" class="bg-linear-to-r h-2 rounded-full from-blue-500 to-cyan-400"></div>
          </div>
          <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">82%</span>
        </div>
        <div class="items-center justify-between flex">
          <span class="text-xs text-gray-400 dark:text-gray-500">
            Vence:
            <span class="text-amber-500 font-medium">08 Dic 2024</span>
          </span>
          <div class="flex gap-1">
            <button type="button" class="btn btn-ghost btn-square btn-sm">
              <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
            </button>
            <a routerLink="/tareas" class="btn btn-ghost btn-square btn-sm text-primary inline-flex">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6M3 21h18M3 10l9-7 9 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      </div>

      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition overflow-hidden">
        <div class="h-2 bg-linear-to-r from-emerald-500 to-green-500"></div>
        <div class="p-5">
        <div class="items-start justify-between mb-3 flex">
          <div>
            <span class="text-xs bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 px-2 py-0.5 rounded-lg font-medium dark:text-emerald-400">Comercial</span>
            <h4 class="font-bold text-gray-800 text-sm mt-1.5 dark:text-white">Aviso de Funcionamiento Plaza Central</h4>
          </div>
          <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg font-medium dark:text-green-400">Completado</span>
        </div>
        <p class="text-xs text-gray-500 items-center mb-3 dark:text-gray-400 flex gap-1">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path></svg>
          Zapopan, Guadalajara
        </p>
        <div class="items-center mb-4 flex gap-2">
          <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-2 flex-1">
            <div style="width: 100%;" class="bg-linear-to-r h-2 rounded-full from-emerald-500 to-green-400"></div>
          </div>
          <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">100%</span>
        </div>
        <div class="items-center justify-between flex">
          <span class="text-xs text-gray-400 dark:text-gray-500">
            Vence:
            <span class="text-green-500 font-medium">Entregado</span>
          </span>
          <div class="flex gap-1">
            <button type="button" class="btn btn-ghost btn-square btn-sm">
              <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
            </button>
            <a routerLink="/tareas" class="btn btn-ghost btn-square btn-sm text-primary inline-flex">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6M3 21h18M3 10l9-7 9 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

